import {
  ProductAnalyticsEvent,
  ProductAnalyticsEventV2
} from '@dadohr/shared/domainTypes/productAnalytics';
import { CF } from '@dadohr/shared/versions';
import { useMemo } from 'react';
import { matchPath } from 'react-router';
import ENVS from '../../env.json';
import { PAGES } from '../../sitemap';
import { useCurrentUser } from '../currentUser';
import { callFirebaseFunction } from '../firebaseFunctions';

// By default we don't track internal users.
// Change this to true while you develop and want to see
// your own events pop up.
const TRACK_INTERNAL_USERS = false;
// Dev normally should skip tracking altogether, we can
// however override this for development purposes.
// This will also automatically track internal users.
const TRACK_IN_DEV = true;

// Hardcoded disabling of prod tracking for now, so that we can
// merge the branch without starting to track immediately
const NO_TRACKING_IN_PROD = false;

const getPageName = (currentPath: string) => {
  const currentPage = PAGES.find((p) =>
    matchPath(currentPath, {
      ...p,
      exact: true
    })
  );
  return currentPage?.trackingName || 'Unknown';
};

const trackEventViaCf = async (
  orgId: string,
  event: ProductAnalyticsEvent | ProductAnalyticsEventV2
) => {
  const isDevEnv = ENVS.env.name === 'Development';
  const pathname = window.location.pathname;
  const args = {
    orgId,
    event,
    currentPage: {
      name: getPageName(pathname),
      path: pathname
    },
    trackInternalUsers: TRACK_INTERNAL_USERS || isDevEnv
  };
  console.debug('tracking PA event', event);
  if (isDevEnv && !TRACK_IN_DEV) {
    return;
  }
  if (!isDevEnv && NO_TRACKING_IN_PROD) {
    return;
  }
  await callFirebaseFunction(
    CF.productAnalytics.trackAdminAppEvent,
    args
  ).catch((err) =>
    console.log('TRACK_PA_EVENT_FAILED', args.event.name, args, err)
  );
};

export const useProductAnalytics = () => {
  const { org } = useCurrentUser();
  const orgId = org.id;
  return useMemo(() => {
    const trackEvent = async (
      event: ProductAnalyticsEvent | ProductAnalyticsEventV2
    ) => {
      try {
        // add set timer to check if event is valid(not sure if this is necessary)
        // Call backend service/CF
        await trackEventViaCf(orgId, event);
      } catch (error) {
        console.log('PA_ERROR', error);
      }
    };
    return { trackEvent };
  }, [orgId]);
};
